import { combineReducers } from 'redux';
import { reducer as form } from 'redux-form';
import * as reducers from './reducers';

export const rootReducer = combineReducers({ ...reducers, form });
